import validity_mixin from "~/mixins/validity"

export default {
  mixins: [validity_mixin],
  data: function () {
    return {
      validity: {
        email: true,
        password: true,
      },
    }
  },
  methods: {
    validate_email: function () {
      return this.checkEmail(this.email.trim())
    },
    validate_password: function () {
      return this.checkPassword(this.password)
    },
  },
}
